exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drop-area[data-v-8363e3ec] {\n  width: 100%;\n  color: black;\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 1.3em;\n  border: 2px dashed #d2202f;\n  border-radius: 10px;\n  font-weight: normal;\n\n  padding: 0 16px;\n  min-height: 70px;\n}\n.ghost-drop[data-v-8363e3ec] {\n  opacity: 0.5;\n  border: 2px dashed black;\n  padding: 10px;\n}\n[data-v-8363e3ec] .v-input--selection-controls.v-input .v-label {\n  margin-bottom: 0;\n}\n", ""]);

// exports
